export default "__VITE_PUBLIC_ASSET__74d37382__"